import { Action } from '@/_core/fluxstore/types';
import { StorymapState, ViewType } from '../types';
import { useStorymapStore } from '../useModule';
import { allCards, getCardById, isActivity, isSubtask, isTask } from '../use';
import { PasteCopiedCard } from './pasteCopiedCard';
import { MoveCardToActivity } from './moveCard/moveCardToActivity';
import { MoveCardToTask } from './moveCard/moveCardToTask';
import { MoveCardToSubtask } from './moveCard/moveCardToSubtask';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class PasteCard extends Action<StorymapState> {
    public static ACTION_TYPE = 'PasteCard';

    public constructor(public destinationCardId: string) {
        super(PasteCard.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: PasteCard): Promise<boolean> => {
    if (state.currentViewType === ViewType.Tracking) {
        return false;
    }

    const copiedCard = allCards.value.find((x) => x.isCopied);
    const cutCard = allCards.value.find((x) => x.isCut);

    if (copiedCard != null) {
        dispatch(new PasteCopiedCard(copiedCard.id, action.destinationCardId));
    } else if (cutCard != null) {
        const destinationCard = getCardById(action.destinationCardId);

        if (isActivity(destinationCard)) {
            let order = destinationCard.order + 1;
            if (isActivity(cutCard) && cutCard.order < destinationCard.order) {
                order--;
            }

            dispatch(new MoveCardToActivity(cutCard.id, order));
        }
        if (isTask(destinationCard)) {
            let order = destinationCard.order + 1;
            if (isTask(cutCard) && cutCard.activityId == destinationCard.activityId && cutCard.order < destinationCard.order) {
                order--;
            }

            dispatch(new MoveCardToTask(cutCard.id, destinationCard.activityId, order));
        }
        if (isSubtask(destinationCard)) {
            let order = destinationCard.order + 1;
            if (
                isSubtask(cutCard) &&
                cutCard.taskId == destinationCard.taskId &&
                cutCard.releaseId == destinationCard.releaseId &&
                cutCard.order < destinationCard.order
            ) {
                order--;
            }

            dispatch(new MoveCardToSubtask(cutCard.id, destinationCard.releaseId, destinationCard.taskId, order));
        }
    }

    return true;
};

const reducer = (): void => {
    // @ts-ignore
};

//@ts-ignore
registerMiddleware(PasteCard.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(PasteCard.ACTION_TYPE, reducer);
